export default class NotImplemented extends Error {
    constructor() {
        super("Method not implemented");
    }
}
